import { FitnessTrackerGraphics } from 'app/components/berichte/fitnesstracker/FitnessTrackerGraphics';
import { AgenturModel } from 'app/models/agentur.model';
import { BranchenplanungPosDef } from 'app/models/branchenplanung/bp.pos.def';
import { JpgAmisNowQualiContent } from 'app/components/documents/jpg/JpgThemenContent';
import { JpgAkumaAktionenWidget } from 'app/components/documents/jpg/JpgAkumaAktionenWidget';
import colors from 'assets/scss/colors.module.scss';
import { IJpgThemaDef } from 'app/stores/ui/jpg.themen.ui.store';
import { AgtNachfolgePlanungAgenturInfo } from 'app/components/berichte/nachfolgeplanung/AgtNachfolgePlanungAgenturInfo';
import { AgtNachfolgePlanungBestandBewertung } from 'app/components/berichte/nachfolgeplanung/AgtNachfolgePlanungBestandBewertung';
import Config from 'Config';
import { AgtNachfolgePlanungDigitalReport } from 'app/components/berichte/nachfolgeplanung/AgtNachfolgePlanungDigitalReport';
import { AgenturPersonalWidget } from 'app/components/agt/overview/AgenturPersonalWidget';
import { AgenturBetreuerWidget } from 'app/components/agt/overview/AgenturBetreuerWidget';
import { JpgLeadNowWidget } from './JpgLeadNowWidget';

let JpgThemenDef: IJpgThemaDef[] = [
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'gup',
		themaShort: 'GUP',
		thema: 'Mein Google Unternehmensprofil',
		byLine: 'Sichtbar sein DigitalPersönlich',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="sichtbarSein" onClose={() => {}} homeAlone={true} />,
		background: colors.green,
		color: colors.white,
		adzKey: 'googleProfile',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'smt',
		themaShort: 'SMT',
		thema: 'Einsatz der Social Media Toolbox',
		byLine: 'Sichtbar sein DigitalPersönlich PLUS',
		handlungsEmpfehlungen: ['LinkedIn', 'XING'],
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="socialToolbox" onClose={() => {}} homeAlone={true} />,
		background: colors.green,
		color: colors.white,
		adzKey: 'socialMediaToolbox',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'amis',
		themaShort: 'AMIS.NOW',
		thema: 'AMIS.NOW Aufgaben',
		byLine: 'Jeden Kontakt Nutzen',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="amis" onClose={() => {}} homeAlone={true} />,
		background: colors.turquoise,
		color: colors.white,
		adzKey: 'amisNow',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'sts',
		themaShort: 'S2S',
		thema: 'Service-to-Sale',
		byLine: 'Jeden Kontakt Nutzen PLUS',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="sts" onClose={() => {}} homeAlone={true} />,
		handlungsEmpfehlungen: ['Vertriebschancen im Agenturteam nutzen', 'Anmeldung Schulung Agenturteam'],
		background: colors.turquoise,
		color: colors.white,
		adzKey: 'serviceToSale',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'akumaPlaner',
		themaShort: 'AKUMA',
		thema: 'AKUMA Planer und Aktionen',
		byLine: 'Jeden Kunden kontaktieren',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="akumaPlaner" onClose={() => {}} homeAlone={true} />,
		background: colors.yellow,
		adzKey: 'akumaPlaner',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'akumaPrime',
		themaShort: 'AKUMA Prime',
		thema: 'AKUMA Prime',
		byLine: 'Jeden Kunden kontaktieren PLUS',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="akumaPrime" onClose={() => {}} homeAlone={true} />,
		background: colors.yellow,
		adzKey: 'akumaPrime',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'maz',
		themaShort: 'MAZ',
		thema: 'Meine Allianz',
		byLine: 'Immer da sein',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="maz" onClose={() => {}} homeAlone={true} />,
		background: colors.primary,
		color: colors.white,
		adzKey: 'meineAllianz',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'mazPlus',
		themaShort: 'KVM',
		thema: 'VU Inbound (KVM)',
		byLine: 'Immer da sein Plus',
		dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="vuinbound" onClose={() => {}} homeAlone={true} />,
		handlungsEmpfehlungen: ['Einrichtung Inbound', 'Förderung Erreichbarkeit'],
		background: colors.primary,
		color: colors.white,
		adzKey: 'kvmSupport',
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'leadnow',
		themaShort: 'Empfehlungen',
		thema: 'Allianz Empfehlungen',
		byLine: 'Neue Kunden finden',
		handlungsEmpfehlungen: ['Empfehlungsmanagement', 'Kundenzufriedenheit nutzen'],
		background: colors.richGreen,
		color: colors.white,
	},
	{
		sort: 1,
		group: 'ADZ',
		keyThema: 'leadnowPlus',
		themaShort: 'AMIS.NOW Leads',
		thema: 'AMIS.NOW Leads',
		byLine: 'Neue Kunden finden Plus',
		handlungsEmpfehlungen: ['Prüfung AMIS.NOW Leads fähig', 'Einrichtung AMIS.NOW Leads'],
		background: colors.richGreen,
		color: colors.white,
		adzKey: 'leadNow',
		dataComponent: (agt: AgenturModel, year: number) => <JpgLeadNowWidget agt={agt} year={year} />,
	},

	/// ASP
	// Farben siehe Folie 5
	{
		sort: 1,
		group: 'Aktvitätsschwerpunkte',
		keyThema: 'aspVertriebsimpulse',
		themaShort: 'Vertriebsimpulse',
		thema: 'Automatisierte Vertriebsimpulse',
		byLine: 'Kundenaktivierung durch Push-to-Pull',
		background: colors.turquoise,
		color: colors.white,
		handlungsEmpfehlungen: [
			'Monatliches Extra-Einkommen mit Plan12',
			'Existenzabsicherung für Bestandskunden leicht gemacht',
			'Kinder - Unsere Basis für die Zukunft',
			'Pflege - Sicherheit für morgen',
			'Kundenwachstum mit Versicherungskennzeichen',
			'Kundenansprache mit Einstiegsprodukten',
			'Jahresendspurt P-Sach 2026',
		],
		bpKeys: ['fonds', 'leben', 'kranken', 'psachOhneKraftUnfall', 'kfzHaftPkw', 'unfall', 'firmenSachOhneKraft'],
		dataComponent: (agt: AgenturModel, year: number) => <JpgAkumaAktionenWidget agt={agt} year={year} campaignIds={[24543, 24269, 24347, 24308, 24183, 24242]} />,
	},
	{
		sort: 1,
		group: 'Aktvitätsschwerpunkte',
		keyThema: 'aspSteuerungsimpulse',
		themaShort: 'Steuerungsimpulse',
		thema: 'Aktivierende Steuerungsimpulse',
		byLine: 'Maßgeschneiderte Workshops mit abgestimmten Kundenkontaktpunkten zur Erschließung neuer Themen für Neugeschäft.',
		background: colors.turquoise,
		color: colors.white,
		handlungsEmpfehlungen: [
			'Junge Erwachsene - Unsere Basis für Morgen',
			'EB-Impuls Fortführung 2026',
			'Kein Unternehmen ist zu klein für große Lösungen',
			'SMC',
			'MidCorp',
			'Powerday 1 - Kunden- und Stückewachstum',
			'Powerday 2 - Kunden- und Stückewachstum',
			'Powerday Unfall',
		],
		bpKeys: ['fonds', 'leben', 'kranken', 'firmenSachOhneKraft'],
		dataComponent: (agt: AgenturModel, year: number) => <JpgAkumaAktionenWidget agt={agt} year={year} campaignIds={[25088, 24542, 24582, 24622]} />,
	},
	{
		sort: 1,
		group: 'Aktvitätsschwerpunkte',
		keyThema: 'aspEntwicklungsimpulse',
		themaShort: 'Entwicklungsimpulse',
		thema: 'Entwicklungsimpulse',
		byLine: 'Mitgliedschaftskonzept: Formate, Vertriebsszenarien und Betreuung - der Weg zur Fachagentur.',
		background: colors.turquoise,
		color: colors.white,
		handlungsEmpfehlungen: ['Community Kapitalmarktexpertise', 'Fokusinitiative betriebliche Vorsorge', 'ExzellenzNetzwerk Firmen'],
		bpKeys: ['fonds', 'leben', 'kranken', 'firmenSachOhneKraft'],
		dataComponent: (agt: AgenturModel, year: number) => (
			<>
				<div className="pad-1rem color-grey">
					<p>Keine Aktion, nur Selekt & Formatkennung ab Q2 2026</p>
				</div>
			</>
		),
	},
	{
		sort: 1,
		group: 'AMIS.NOW',
		keyThema: 'amisnowQuali',
		themaShort: 'AMIS.NOW',
		thema: 'Qualifizierung',
		byLine: 'AMIS.NOW',
		/* TODO textcomp: content raus und alle amis now verlinkungen in das Widget */
		textComponent: <JpgAmisNowQualiContent />,
		background: colors.darkYellow,
		color: colors.white,
	},

	{
		sort: 1,
		group: 'Nachfolgeplanung',
		keyThema: 'uebergabe',
		themaShort: 'Bst. Übergabe Quali',
		thema: 'Bestandsübergabe - Bestandsqualität',
		byLine: 'Bestandsqualität vor Übergabe sicherstellen',
		background: colors.purple,
		color: colors.white,
		handlungsEmpfehlungen: [
			'Risiken im Bestand identifizieren:',
			'MAZ Durchdringung im Bestand',
			'Kundendurchschnittsalter im Bestand',
			'EVK-Anteil im Bestand',
			'Kundenverteilung nach Produktgebern (Fokus auf Einjahresverträge bspw. KFZ)',
			'Netto-Kundenwachstum',
			'Netto-Stückewachstum',
			// Ggf. Link zu FIV.NOW hinterlegen
		],
		dataComponent: (agt: AgenturModel, year: number) => (
			<>
				<AgtNachfolgePlanungBestandBewertung agtId={agt.agtId} vorJahr={Config.currentPlanYear - 1} />
				<AgtNachfolgePlanungDigitalReport agtId={agt.agtId} />
			</>
		),
	},
	{
		sort: 1,
		group: 'Nachfolgeplanung',
		keyThema: 'personaluebernahme',
		themaShort: 'Personalübernahme',
		thema: 'Personalübernahme klären',
		byLine: '',
		background: colors.purple,
		color: colors.white,
		handlungsEmpfehlungen: [
			'Gibt es bestehendes Personal, das übernommen werden kann?',
			'Übernahme sicherstellen',
			'ZVP anstoßen (Hinweis: Beim Einsatz von bestehendem Personal in einer neuen Agentur ist ein ZVP zwingend erforderlich)',
		],
		dataComponent: (agt: AgenturModel, year: number) => (
			<>
				<AgtNachfolgePlanungAgenturInfo agtId={agt.agtId} />
				<AgenturPersonalWidget disableEdit={true} disableCollapse={true} />
			</>
		),
	},
	{
		sort: 1,
		group: 'Nachfolgeplanung',
		keyThema: 'buep',
		themaShort: 'Bst. Übergabe-Nahtlos',
		thema: 'Bestandsübergabe - Nahtlose Übergabe',
		byLine: 'Nahtlose Übergabe sicherstellen',
		background: colors.purple,
		color: colors.white,
		handlungsEmpfehlungen: ['Top Kunden im Bestand identifizieren und weiteres Vorgehen besprechen', 'Zukunftsplan für Senior-Partner thematisieren'],
		dataComponent: (agt: AgenturModel, year: number) => (
			<>
				<AgtNachfolgePlanungAgenturInfo agtId={agt.agtId} />
			</>
		),
	},

	{
		sort: 1,
		group: 'Neugründung',
		keyThema: 'fachlichvertief',
		themaShort: 'Fachliche Vertiefung',
		thema: 'Fachliche Vertiefung / Spezialisteneinbindung ',
		byLine: 'DSE & Fläche',
		background: colors.purple,
		color: colors.white,
		handlungsEmpfehlungen: ['Übersicht mit Ansprechpartnern auf GS aushändigen', 'Aufgabenbereich der DSE erläutern', 'Menükarten in Amis.online aufzeigen'],
		dataComponent: (agt: AgenturModel, year: number) => (
			<>
				<AgenturBetreuerWidget disableCollapse={true} />
			</>
		),
	},
	{
		sort: 1,
		group: 'Neugründung',
		keyThema: 'neudigi',
		themaShort: 'Digitale Vertiefung ',
		thema: 'Digitale Vertiefung',
		byLine: '',

		background: colors.purple,
		color: colors.white,
		handlungsEmpfehlungen: [
			'Prozesse auf Agenturebene beleuchten',
			'Grundlagen zur „Agentur der Zukunft“ erläutern inkl. Fitnessplan & Fitnesstracker',
			'Unterstützungsangebote aufzeigen: EDT/EDP, Menükarte der Web-DSE thematisieren',
		],
		//dataComponent: (agt: AgenturModel, year: number) => <></>,
	},
];

BranchenplanungPosDef.forEach((bpPosDef) => {
	JpgThemenDef.push({
		sort: 1,
		group: 'Branchenplanung',
		keyThema: bpPosDef.planKey,
		thema: bpPosDef.posText,
		themaShort: bpPosDef.posText,
		background: colors.softStone,
		bpKeys: [bpPosDef.planKey],
		handlungsEmpfehlungen: ['Schwerpunktagentur setzen', 'Aktivitäten/Initiativen zur Produktionssteigerung', 'Aktivitäten/Initiativen zur fachlichen Qualifizierung'],
	});
});

JpgThemenDef = JpgThemenDef.concat([
	{
		sort: 1,
		group: 'Nachhaltigkeit',
		keyThema: 'bwl',
		themaShort: 'BWL',
		thema: 'Betriebswirtschaftliche Geamtsituation',
		background: colors.softLime,
		handlungsEmpfehlungen: ['Überprüfung Ausgabensituation', 'Überprüfung Einnahmensituation', 'Neugeschäft', 'Geschäftsplan - Incentives - Vertriebsschwerpunkte'],
	},
	{
		sort: 1,
		group: 'Nachhaltigkeit',
		keyThema: 'kundendaten',
		themaShort: 'NPS',
		thema: 'Kundendaten und NPS',
		background: colors.softLime,
		handlungsEmpfehlungen: [
			'Digital-ID',
			'Ableitungen aus Kundenzufriedenheitsreport',
			'Einholung der Gesellschafts wEWE',
			'Bedarf Personalkapazität',
			'Vorgehensweise Personalsuche Bürokraft und Zweitverkäufer',
			'Personalführung',
			'Coaching',
		],
	},
	{
		sort: 1,
		group: 'Nachhaltigkeit',
		keyThema: 'personal',
		themaShort: 'Personal',
		thema: 'Agentur und Personal',
		background: colors.softLime,
		handlungsEmpfehlungen: ['Bedarf Personalkapazität', 'Vorgehensweise Personalsuche Bürokraft und Zweitverkäufer', 'Personalführung', 'Coaching'],
	},
]);

export const JpgFocusThemenDef2026 = JpgThemenDef;
